import TopBar from "component/ui/TopBar";
import styles from "../../Create/Create.css";
import {options} from "component/const/ForShort";
import {useLocation} from "react-router-dom";
import {useEffect, useState} from "react";
import SubmitButton from "./component/SubmitButton";
import axios from "axios";
import {restUrl} from "../../../../apiUrl";
import {AboutTest} from "../component/AboutTest";

export default function TestShort(){
    const [answers, setAnswers] = useState([]);
    const {state} = useLocation();
    const [problems, setProblems] = useState([]);
    
    useEffect(() => {
        axios.get(`${restUrl}/activity_test_problem_view_short_create?test_id=eq.${state.testId}`).then((data) => {
            setProblems(data.data);
        });
    }, []);
    
    useEffect(() => {
        if (problems.length > 0) {
            setAnswers(problems.map(problem => ({ problem_id: problem.id, application_id: state.appId, response: "" })));
        }
    }, [problems]);
    
    const onChange = (value, index) => {
        const updatedAnswers = [...answers];
        if (updatedAnswers[index]) {
            updatedAnswers[index] = { ...updatedAnswers[index], response: value };
            setAnswers(updatedAnswers);
            return;
        }
    };
    
    return (
        <>
            <AboutTest testId={state.testId} />
            <TopBar title="출제 내용" />
            {problems?.map((it, index) => (
                <section key={it.type + index.toString()} className={"problemSection"}>
                    <div className="problemContainer borderRight !p-2">
                        <div style={{ display: "flex" }}>
                            <span style={styles.index}>{String(index + 1).padStart(2, "0").padEnd(3, ".") + it.problem}</span>
                        </div>
                        {it.selections?.map((i, ind) => (i !== "" ?
                                <div key={String(index).padStart(2, "0").padEnd(3, ".") + ind.toString()} style={{ marginLeft: "20px", display: "flex" }}>
                                    <span style={styles.index}>{[options[0].key, options[3].key, options[4].key].includes(it.type) && (ind + 1) + ". " + i}</span>
                                </div> : null
                        ))}
                    </div>
                    <div className="infoContainer p-2">
                        {[options[0].key, options[1].key, options[2].key].includes(it.type) && <>
                            <div>
                                <span>난이도:</span>
                                <span style={{ fontWeight: "bold" }}>{it.difficulty}</span>
                            </div>
                            <div>
                                <span>점수:</span>
                                <span style={{ fontWeight: "bold" }}>{it.score}</span>
                            </div>
                        </>}
                        {[options[0].key, options[1].key, options[3].key, options[4].key].includes(it.type) && <div className="DSContainer">
                            <fieldset>
                                {it.selections?.map((i, ind) => (<label key={i + ind.toString()}>
                                    <input
                                        className={"inputBorder "}
                                        type="radio" checked={answers[index]?.response === i}
                                           onChange={() => onChange(i, index)} />
                                    {i}
                                </label>))}
                            </fieldset>
                        </div>}
                        {it.type === options[2].key && <>
                            <span>오타 {it.allowTypo ? "허용" : "조심"}</span>
                            <span>띄어쓰기 {it.allowSpacingTypo ? "상관 없음" : "조심"}</span>
                            <input value={answers[index]?.response || ""}
                                   placeholder={"입력하세요"}
                                   className={"inputBorder inputTextAreaMargin"}
                                   onChange={(e) => onChange(e.target.value, index)}/>
                        </>}
                    </div>
                </section>
            ))}
            <div className="saveContainer">
                <SubmitButton answers={answers} />
            </div>
        </>
    );
}
